import { SwUpdate } from '@angular/service-worker';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { interval } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { environment } from '@env/environment';
import { add, isBefore } from 'date-fns';

@Injectable()
export class CheckForUpdateService {
  private static readonly CHECK_INTERVAL_MINUTES = 3;
  private static readonly FORCED_CHECK_INTERVAL_MS = 30 * 60 * 1000;
  private nextCheckTime: Date;

  constructor(private router: Router,
              private updates: SwUpdate,
  ) { }

  public register(): void {
    if (!environment.registerServiceWorker) { return; }

    this.setNextCheckTime();
    this.initializeChecks();
  }

  private initializeChecks(): void {
    interval(CheckForUpdateService.FORCED_CHECK_INTERVAL_MS).subscribe(() => this.checkForUpdate());
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd), debounceTime(500))
      .subscribe(() => this.checkForUpdate());
  }

  private checkForUpdate(): void {
    if (isBefore(this.nextCheckTime, new Date())) {
      if (this.updates.isEnabled) {
        this.updates.checkForUpdate();
      }
      this.setNextCheckTime();
    }
  }

  private setNextCheckTime(): void {
    const minutes = CheckForUpdateService.CHECK_INTERVAL_MINUTES;
    this.nextCheckTime = add(new Date(), { minutes });
  }
}
